module.exports = __webpack_public_path__ + "static/media/wooden-heart-clip.31d453bb.mp3";